/// <reference types="vite-plugin-pwa/react" />
import { useEffect } from "react";
import { useRegisterSW } from "virtual:pwa-register/react";

/**
 * Listens for service-worker updates and auto-reloads when a new
 * version is ready, so users always run the latest code.
 * Also polls every 60 s for updates while the app is open.
 */
export function useAppUpdate() {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_swUrl, registration) {
      // Poll for SW updates every 60 seconds
      if (registration) {
        setInterval(() => {
          registration.update();
        }, 60 * 1000);
      }
    },
  });

  useEffect(() => {
    if (needRefresh) {
      // Auto-apply the update and reload
      updateServiceWorker(true);
    }
  }, [needRefresh, updateServiceWorker]);
}
